'use client';

// BotNotFound - 404 page for invalid bot slugs
// Story 4.1: Access Bot via Public Link

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useLocale, useTranslations } from 'next-intl';
import { BotyIcon } from '@boty/ui';
import { ensureProtocol } from '../../lib/ensureProtocol';

export function BotNotFound() {
  const t = useTranslations('consumer.error');
  const locale = useLocale();
  const creatorUrl = ensureProtocol(
    process.env.NEXT_PUBLIC_CREATOR_URL || 'https://app.boty.app',
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100dvh',
        p: 4,
        textAlign: 'center',
      }}
    >
      <Box sx={{ mb: 3, opacity: 0.5 }}>
        <BotyIcon size={64} />
      </Box>

      <Typography variant="h4" component="h1" gutterBottom>
        {t('notFound.title')}
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4, maxWidth: 400 }}
      >
        {t('notFound.description')}
      </Typography>

      <Button variant="contained" color="primary" href={creatorUrl} size="large">
        {t('notFound.createCta')}
      </Button>

      <Button variant="text" href={`/${locale}/samples`} size="small" sx={{ mt: 2 }}>
        {t('notFound.samplesCta')}
      </Button>
    </Box>
  );
}
